import PropTypes from "prop-types";
import React from "react";
import { Text } from "@mantine/core";

const ValidationError = ({ validation, message }) => {
  // Support both validation object and direct message string
  if (message) {
    return <Text className="error">{message}</Text>;
  }

  if (!validation || validation.isValid || !validation.message) {
    return null;
  }

  return <Text className="error">{validation.message}</Text>;
};

ValidationError.propTypes = {
  validation: PropTypes.object,
  message: PropTypes.string,
};

export default ValidationError;
